import Breakpoint from 'bootstrap-breakpoints'
import constants from './constants'
import { Modal, Tooltip } from 'bootstrap'
import jQuery from 'jquery'

export const getData = (objName) => {
  return typeof window[objName] !== 'undefined' ? window[objName] : null
}

export const getDataAttr = (obj, datastr, defVal) => {
  let str = ''
  if (typeof defVal !== 'undefined') str = defVal
  if (typeof obj.data(datastr) !== 'undefined') str = obj.data(datastr)
  return str
}

export const randomNumber = (length = 10) => {
  let result = ''
  const characters = '0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    // prettier-ignore
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const scrollToError = (offsetY = 0) => {
  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: jQuery('.alert')?.offset()?.top - offsetY,
    },
    500,
    'linear'
  )
}

export const scrollToValidation = (offsetY = 50) => {
  // prettier-ignore
  const elements = jQuery('*.field-validation-error')
  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: elements.first().offset().top - offsetY,
    },
    500,
    'linear'
  )
}

export const scrollToTop = () => {
  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: jQuery('html').offset().top,
    },
    500,
    'linear'
  )
}

export const scrollToElem = (elem, offsetY = 0) => {
  if (!elem.length) {
    return
  }

  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: elem.offset().top - offsetY,
    },
    500
  )
}

export const hasValue = (val) => {
  return typeof val !== 'undefined' && val !== null && val !== ''
}

export const isPositiveNum = (val) => {
  return hasValue(val) && isNumeric(val) && val > 0
}

export const getUrlParam = (parameter, defaultValue) => {
  const searchParams = new URL(window.location.href).searchParams

  for (const [key, value] of searchParams.entries()) {
    if (key === parameter) {
      return value
    }
  }

  return defaultValue
}

export const appendUrlParam = (parameter, value) => {
  const url = new URL(window.location.href)

  const searchParams = url.searchParams

  urlParamExists(parameter)
    ? searchParams.set(parameter, value)
    : searchParams.append(parameter, value)

  history.pushState({}, null, url)
}

export const appendUrlParams = (parameters, values) => {
  const url = new URL(window.location.href)
  const searchParams = url.searchParams

  parameters.forEach((i, index) => {
    urlParamExists(i)
      ? searchParams.set(i, values[index])
      : searchParams.append(i, values[index])
  })

  history.pushState({}, null, url)
}

export const urlParamExists = (field) => {
  const url = window.location.href
  if (url.indexOf(`?${field}=`) !== -1) return true
  else if (url.indexOf(`&${field}=`) !== -1) return true
  return false
}

export const removeURLParameter = (key) => {
  window.history.replaceState('', '', removeURLParameterFn(key))
}

export const removeURLParameterFn = (parameter) => {
  const url = window.location.href
  // prefer to use l.search if you have a location/link object
  const urlparts = url.split('?')
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`
    const pars = urlparts[1].split(/[&;]/g)

    // reverse iteration as may be destructive
    for (let i = pars.length - 1; i >= 0; i--) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '')
  }
  return url
}

export const isNumber = (evt) => {
  const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const keyPressed = evt.key

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault()
  }
}

export const getPrevalueText = (array, value) => {
  const entry = array.find((i) => i.value === value)

  return entry ? entry.text : ''
}

export const flatten = (array) => {
  return array.reduce(function (flat, toFlatten) {
    return flat.concat(
      Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
    )
  }, [])
}

export const fileTypeIsJpeg = (value) => {
  return value === constants.fileTypes.jpeg
}

export const fileTypeIsPdf = (value) => {
  return value === constants.fileTypes.pdf
}

export const roundValueByInterval = (value, interval) => {
  const modulo = value % interval
  const intervalHalf = interval / 2

  if (modulo === 0) {
    return value
  }

  if (modulo < intervalHalf) {
    return value - modulo
  }
  return value - modulo + interval
}

export const scrDesktops = () => {
  Breakpoint.init()
  return Breakpoint.is('lg') || Breakpoint.is('md')
}

export const scrDevices = () => {
  Breakpoint.init()
  return Breakpoint.is('sm') || Breakpoint.is('xs')
}

export const isExpEditor = () => {
  return document.body.classList.contains('exp-editor')
}

export const iniTooltips = (element) => {
  const tooltips = Array.from(
    element.querySelectorAll('[data-bs-toggle="tooltip"]')
  )

  tooltips.map((i) => {
    new Tooltip(i)
  })
}

export const iniModals = (element) => {
  const modals = Array.from(
    element.querySelectorAll('[data-bs-toggle="modal"]')
  )

  modals.map((i) => {
    new Modal(i)
  })
}

export const getRandomGradient = () => {
  const max = constants.gradients.length
  const index = Math.floor(Math.random() * Math.floor(max))

  const { start, finish } = constants.gradients[index]

  return `linear-gradient(135deg, ${start} ${finish})`
}

export const getReferrer = () => {
  const referrer = document.referrer

  if (!referrer) {
    return '/'
  }

  try {
    const referrerUrl = new URL(referrer)
    const documentUrl = new URL(document.URL)

    if (referrerUrl.host !== documentUrl.host) {
      return '/'
    }

    return referrer
  } catch (e) {
    return '/'
  }
}

export const isNumeric = (str) => {
  if (typeof str === 'number') {
    return true
  }

  // we only process strings!
  if (typeof str !== 'string') {
    return false
  }
  // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  // ...and ensure strings of whitespace fail
  return !isNaN(str) && !isNaN(parseFloat(str))
}

export const getLocaleFromLangAttr = () => {
  const { lang, locale } = constants
  const langAttr = document.documentElement.lang
  let res
  switch (langAttr) {
    case lang.el:
      res = locale.el
      break
    default:
      res = locale.en
  }
  return res
}

export const roundNumberBy100 = (number) => {
  return Math.round(number / 100) * 100
}

export const formatCurrency = (currency, price, position) => {
  const defaultCurrency = 'EUR'
  const locale = document.documentElement.lang
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || defaultCurrency,
  })

  // Extract the formatted price parts
  const parts = formatter.formatToParts(price)
  const currencySymbol = parts.find((part) => part.type === 'currency').value
  const formattedPrice = parts
    .filter((part) => part.type !== 'currency')
    .map((part) => part.value)
    .join('')

  // Place the currency symbol based on the desired position
  if (position === 'after') {
    return `${formattedPrice} ${currencySymbol}`
  }
  return `${currencySymbol} ${formattedPrice}`
}

export const maskStringLowerCase = (str) => {
  if (!str) {
    return ''
  }
  const firstLetter = str[0]?.toLowerCase()
  const lastLetter = str[str.length - 1]?.toLowerCase()
  return `${firstLetter}${'*'.repeat(Math.max(0, str.length - 2))}${lastLetter}`
}
